import { useEffect } from 'react';

// Leyden `SkipLinks` renders one `<li><a id="els-skiplink-<section>" href="#<section>">` per entry
// in `skipLinkMappings` (@AppRoutes/constants). That list is app-wide and static, so every route
// advertises a "Skip to Footer" link — including routes that deliberately render no footer.
const FOOTER_SKIP_LINK_ID = 'els-skiplink-footer';

/**
 * Hides the app-wide "Skip to Footer" skip link while a footer-less route is mounted.
 *
 * WCAG 2.4.1 Bypass Blocks (A): a skip link whose target does not exist is a broken bypass
 * mechanism. It is worse than inert here — Leyden's `SkipLinks` click handler does
 * `document.getElementById(target).setAttribute('tabindex', '-1')` with no null guard, so
 * activating the link on a footer-less route throws a TypeError. Removing the link from the
 * list is the only fix available without patching the Leyden package.
 *
 * Restores the original `display` on unmount so footer-bearing routes are unaffected.
 * Consolidates the copies in DrawStructureContainer, StructureEditorPageComponent,
 * QueryContainerBase and HeatmapContainer.
 */
export default function useHiddenFooterSkipLink() {
  useEffect(() => {
    const skipLink = document.getElementById(FOOTER_SKIP_LINK_ID);
    const listItem = skipLink?.parentElement;
    if (!listItem) return undefined;

    const previousDisplay = listItem.style.display;
    listItem.style.display = 'none';

    return () => {
      listItem.style.display = previousDisplay;
    };
  }, []);
}
